import { shallowReactive, computed, readonly } from 'vue';
import { DEFAULT_PER_PAGE } from '../helpers/constants';

export default function useSimplePagination(perPage = DEFAULT_PER_PAGE) {
  const pagination = shallowReactive({
    currentPage: 1,
    perPage,
    total: 0
  });

  const from = computed(() => (
    pagination.total ? (pagination.currentPage * pagination.perPage) - (pagination.perPage - 1) : 0
  ));
  const to = computed(() => Math.min(pagination.total, pagination.currentPage * pagination.perPage));

  const setPage = (page) => {
    pagination.currentPage = page;
  };

  const setTotal = (total) => {
    pagination.total = total;
  };

  return {
    pagination: readonly(pagination),
    from,
    to,
    setPage,
    setTotal
  };
};
